<template>
  <el-dialog
    :visible.sync="visible"
    title="合同详情"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >
    <el-form :model="dataForm" ref="dataForm" label-width="120px">
      <el-card v-if="dataForm && dataForm.id" style="margin-bottom:20px;">
        <div slot="header" class="card-header">
          <div>合同信息</div>
        </div>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="合同编号：">
              {{ dataForm.code }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同总价：">
              {{ moneyFormat(dataForm.totalAmount) }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交付日期：">
              {{ dataForm.deadline }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="操作人：">
              {{ dataForm.creatorName }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="操作时间：">
              {{ dataForm.createDate }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注：" prop="remark">
          {{ dataForm.remark || "暂无" }}
        </el-form-item>
      </el-card>
      <el-tabs v-model="currentTab" type="card">
        <el-tab-pane label="合同明细" name="1">
          <DetailList :dataList="dataForm.detailList"></DetailList>
        </el-tab-pane>
        <el-tab-pane label="原料明细" name="2">
          <MaterialList :dataList="dataForm.materialList"></MaterialList>
        </el-tab-pane>
        <el-tab-pane label="发货计划" name="3">
          <PlanList :dataList="dataForm.planList"></PlanList>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import DetailList from "./detail-list.vue";
import MaterialList from './material-list.vue';
import PlanList from './plan-list.vue';
export default {
  components: { DetailList,MaterialList ,PlanList},
  data() {
    return {
      id: "",
      visible: false,
      currentTab:'1',
      dataForm: {
        agreementCode: "",
        agreementId: "",
        code: "",
        createDate: "",
        creator: "",
        creatorName: "",
        deadline: "",
        detailList: [],
        factoryId: "",
        factoryName: "",
        id: "",
        productCount: "",
        remark: "",
        status: "",
        totalAmount: "",
        totalCount: "",
      },
    };
  },
  methods: {
    init() {
      this.getInfo();
      this.visible = true;
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/agreement/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          res.data.detailList.forEach((item) => {
            item.totalAmount = item.count * item.amount;
          });
          this.dataForm = res.data;
        })
        .catch(() => {});
    },
    cancel() {
      this.visible = false;
    },
  },
};
</script>
